/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Pre_Render_Frame_Cache_Failed_ToastInputs */

const en_pre_render_frame_cache_failed_toast = /** @type {(inputs: Pre_Render_Frame_Cache_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to pre-render frame cache. ${i?.error}`)
};

const fr_pre_render_frame_cache_failed_toast = /** @type {(inputs: Pre_Render_Frame_Cache_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de la pré-génération du cache d'images. ${i?.error}`)
};

const de_pre_render_frame_cache_failed_toast = /** @type {(inputs: Pre_Render_Frame_Cache_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Vorrendern des Frame-Caches. ${i?.error}`)
};

const it_pre_render_frame_cache_failed_toast = /** @type {(inputs: Pre_Render_Frame_Cache_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile pre-renderizzare la cache dei frame. ${i?.error}`)
};

const ru_pre_render_frame_cache_failed_toast = /** @type {(inputs: Pre_Render_Frame_Cache_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось предварительно отрендерить кэш кадров. ${i?.error}`)
};

const es_pre_render_frame_cache_failed_toast = /** @type {(inputs: Pre_Render_Frame_Cache_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al precargar la caché de fotogramas. ${i?.error}`)
};

const zh_cn2_pre_render_frame_cache_failed_toast = /** @type {(inputs: Pre_Render_Frame_Cache_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`预渲染帧缓存失败。${i?.error}`)
};

const ja_pre_render_frame_cache_failed_toast = /** @type {(inputs: Pre_Render_Frame_Cache_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`フレームキャッシュのプリレンダリングに失敗しました。${i?.error}`)
};

const hi_pre_render_frame_cache_failed_toast = /** @type {(inputs: Pre_Render_Frame_Cache_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`फ्रेम कैश को प्री-रेंडर करने में विफल। ${i?.error}`)
};

const pt_pt2_pre_render_frame_cache_failed_toast = /** @type {(inputs: Pre_Render_Frame_Cache_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao pré-renderizar o cache de quadros. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to pre-render frame cache. {error}" |
*
* @param {Pre_Render_Frame_Cache_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const pre_render_frame_cache_failed_toast = /** @type {((inputs: Pre_Render_Frame_Cache_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pre_Render_Frame_Cache_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_pre_render_frame_cache_failed_toast(inputs)
	if (locale === "de") return de_pre_render_frame_cache_failed_toast(inputs)
	if (locale === "it") return it_pre_render_frame_cache_failed_toast(inputs)
	if (locale === "ru") return ru_pre_render_frame_cache_failed_toast(inputs)
	if (locale === "es") return es_pre_render_frame_cache_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_pre_render_frame_cache_failed_toast(inputs)
	if (locale === "ja") return ja_pre_render_frame_cache_failed_toast(inputs)
	if (locale === "hi") return hi_pre_render_frame_cache_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_pre_render_frame_cache_failed_toast(inputs)
	return en_pre_render_frame_cache_failed_toast(inputs)
});